import { setJobFilter } from "@/hooks/job-filters";
import { getJobListingData, JobListing , CustomToastrAction, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode} from "@/imports-files/pages/clients/jobs/job";
import { addParamsToUrl } from "../pages/admins/dashboard/clients/common";
import PageStyle from "@/styles/pages/clients/job-sharing/_index.module.scss";

export function closeJobModal(event, setJobFilter)
{
    setJobFilter('Close');
}


export async function resetJobModal( setFiltersValue, setModal,setJobList, selectDropdownRef, startDateRef, endDateRef, setStartDate, setEndDate, setLocation, router, setApiError)
{

    var previous_job_filter  =    router.query;
    delete previous_job_filter.start_date;
    delete previous_job_filter.end_date;
    delete previous_job_filter.location;
    delete previous_job_filter.agency_user_emails;
    delete previous_job_filter.agency_user_name_initials;
    delete previous_job_filter.agency_user_photo_urls;
    delete previous_job_filter.agency_user_names;
    addParamsToUrl(previous_job_filter, router);


    setJobFilter(previous_job_filter);
    setFiltersValue(previous_job_filter);
    var result  =    await getJobListingData(previous_job_filter, setApiError);
    setJobList(result.data);  
  

    document.querySelector('.FilterCustomStartDate input').value    = '';
    document.querySelector('.FilterCustomEndDate input').value      = '';

    selectDropdownRef.current.select.clearValue();

    // startDateRef.current?.state?.inputValue = ''
    // endDateRef.current?.state?.inputValue = ''

    setStartDate('');
    setEndDate('');
    setLocation('');
    setModal(false);
}


export async function getAgencyUsers(name_or_email, router)
{
    const body                =   {name_or_email: name_or_email}
    const result              =   await new JobListing().getUserByNameOrEmail(body);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction(); 
    switch (status_code)
    {
        case SUCCESS_REPONSE_CODE:
        const response = result.data;
        return response.users
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        customToastrAction.setNormalToastr(result.response.data.error, 'warning');
        return []
    default: 
        handleOtherResponseCode(status_code, router);
    }
}

export function shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }
  export const renderInputComponent = inputProps => (
    <input className = {PageStyle.Form__Input} autoComplete="password"
    {...inputProps} />
  );
  
  export function getUserSuggestionValue(suggestion) 
  {
    return `${suggestion.user_attributes.email}`;
  }
  
  function showSuggestion(suggestion){
    if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
      return `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
    }
    else if(suggestion.user_attributes.name){
      return `${suggestion.user_attributes.name}`
    }
    else{
      return `${suggestion.user_attributes.email}`
    }
  }
    
    export function renderUserSuggestion(suggestion) {
      return (
        <span>{showSuggestion(suggestion)}</span>
      );
    }

    function escapeRegexCharacters(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    async function getUserSuggestions(value, router) {
      const escapedValue = escapeRegexCharacters(value?.trim());
      
      if (escapedValue === '') {
      return [];
      }
      let finalUsers = await getAgencyUsers(escapedValue, router)
      return finalUsers
    }
    
    export async function onUserSuggestionsFetchRequested(hash, setUsers){    
      let users = await getUserSuggestions(hash.value)
      setUsers(users)
    };
    
    export const onUserSuggestionsClearRequested = (setUsers) => {
      setUsers([])
    };
    
    export function isEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    export function onUserSuggestionSelection(formik, old_emails, email, old_initials, new_initial, setAgencyUserEmails, setAgencyUserInitials){
      if(isEmail(email) && !old_emails.includes(email))
      {
        old_emails.unshift(email)
        old_initials.unshift(new_initial) 
        setAgencyUserEmails([...old_emails])
        setAgencyUserInitials([...old_initials])
      }
    }

    export function handleKeyDown(evt, formik, setAgencyUserEmail, setAgencyUserError, setAgencyUserEmails, setAgencyUserInitials){
      if (["Enter"].includes(evt.key)) {
        evt.preventDefault();
        let email = evt.target.value
        if(isEmail(email))
        {
          { onUserSuggestionSelection(formik, formik.values.agency_user_emails, email, formik.values.agency_user_initials, {email: email, name_initials: null, name: null}, setAgencyUserEmails, setAgencyUserInitials)
            setAgencyUserEmail('')
          }
        }
        else
        {                      
          setAgencyUserError("Invalid Email");
        }
      };
    }

    export function handleEmailDelete(formik, itemIndex, setAgencyUserEmails, setAgencyUserInitials )
    {
      let emails = formik.values.agency_user_emails 
      let name_initials = formik.values.agency_user_initials
      emails.splice(itemIndex, 1)
      name_initials.splice(itemIndex, 1)
      formik.setFieldValue(`agency_user_emails`, [...emails])
      formik.setFieldValue(`agency_user_initials`, [...name_initials])
      setAgencyUserEmails([...emails])
      setAgencyUserInitials([...name_initials])
    }

    export function setQueryParams(router){
      let agency_user_emails = router.query.agency_user_emails
      let agency_user_names = router.query.agency_user_names
      let agency_user_photo_urls = router.query.agency_user_photo_urls
      let agency_user_name_initials = router.query.agency_user_name_initials
      let agency_user_initials = []
      if(agency_user_emails){
        if(Array.isArray(agency_user_emails)){
          agency_user_initials = agency_user_emails.map((x, index) => {
            return {
            name: agency_user_names[index] || agency_user_emails[index],
            photo_url: agency_user_photo_urls[index],
            name_initials: agency_user_name_initials[index]
          }})
        }
        else{
          agency_user_initials = [{
            name: agency_user_names || agency_user_emails,
            photo_url: agency_user_photo_urls,
            name_initials: agency_user_name_initials
          }]
        }
        return agency_user_initials
      }
      else{
        return []
      }
    }

